import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 2048 2048" width="1em" height="1em" {...props}>
    <path
      className="OfficeIconColors_HighContrast"
      d="M614 563l73-72 235 234V102h102v623l235-234 72 72-358 359m973 204H102v-102h1844m0 512H102v-102h1844m0 512H102v-103h1844z"
    />
    <path
      className="OfficeIconColors_m24"
      d="M614 563l73-72 235 234V102h102v623l235-234 72 72-358 359z"
    />
    <path
      className="OfficeIconColors_m22"
      d="M1946 1126H102v-102h1844m0 512H102v-102h1844m0 512H102v-103h1844z"
    />
  </svg>
);

export default SvgComponent;
